export default __webpack_public_path__ + "static/media/project.ca0358fc.png";